import { Person as PersonIcon, Assignment as AssignmentIcon, Dashboard as DashboardIcon, Business as BusinessIcon, Folder as FolderIcon, VerifiedUser, Business, Domain, Badge, Verified, Certificate, Assignment, AssignmentTurnedIn, AssignmentLate, Person, Group, AccountCircle, CardMembership, SettingsTwoTone } from '@mui/icons-material';
import { WorkspacePremium } from '@mui/icons-material';
import VerifiedIcon from '@mui/icons-material/Verified';
const menuItemsForAdmin = [
  { text: 'Manage Issuers', icon: <VerifiedUser />, path: 'manage-issuers' },
  { text: 'Manage Credentials', icon: <CardMembership />, path: 'manage-credentials' },
  { text: 'Manage Assignments', icon: <Assignment />, path: 'manage-assignments' },
  { text: 'Manage Users', icon: <Group />, path: 'manage-users' },
  { text: 'Manage Companies', icon: <BusinessIcon />, path: 'manage-companies' },
  { text: 'Profile', icon: <AccountCircle />, path: 'profile' },
];

const menuItemsForIssuer = [
  { text: 'Manage Company Issuers', icon: <VerifiedUser />, path: 'manage-company-issuers' },
  { text: 'Manage Assignments', icon: <Assignment />, path: 'manage-assignments' },
  { text: 'Manage Credentials', icon: <CardMembership />, path: 'manage-credentials' },
  { text: 'Manage Users', icon: <Group />, path: 'manage-users' },
  // { text: 'Manage Companies', icon: <BusinessIcon />, path: 'manage-companies' },
  // { text: 'Badge Profile', icon: <WorkspacePremium />, path: 'badge-profile' },
  { text: 'Profile', icon: <AccountCircle />, path: 'profile' },
];

const menuItemsForCompanyIssuer = [
  // { text: 'Manage Company Issuers', icon: <VerifiedUser />, path: 'manage-company-issuers' },
  { text: 'Manage Assignments', icon: <Assignment />, path: 'manage-assignments' },
  { text: 'Manage Credentials', icon: <CardMembership />, path: 'manage-credentials' },
  { text: 'Manage Users', icon: <Group />, path: 'manage-users' },
  // { text: 'Manage Companies', icon: <BusinessIcon />, path: 'manage-companies' },
  // { text: 'Badge Profile', icon: <WorkspacePremium />, path: 'badge-profile' },
  { text: 'Profile', icon: <AccountCircle />, path: 'profile' },
];

const menuItemsForUser = [
  { text: 'Dashboard', icon: <DashboardIcon />, path: 'dashboard' },
  { text: 'Approve Badges', icon: <VerifiedIcon />, path: 'approve-badges' },
  { text: 'Badge Profile', icon: <WorkspacePremium />, path: 'badge-profile' },
  { text: 'User Profile', icon: <AccountCircle />, path: 'profile' },
];

export { menuItemsForAdmin, menuItemsForIssuer, menuItemsForUser, menuItemsForCompanyIssuer }